export const REGISTER_ERROR_MESSAGES = {
  USER_ALREADY_REGISTERED: 'USER_ALREADY_REGISTERED',
};
